module.exports = __webpack_public_path__ + "static/media/reports.3e4d7a14.svg";